<template>
  <div class="files-list" data-testid="files-list">
    <ExpansionPanels
      v-if="hasFiles"
      :items="idEnriched"
      :multiple="false"
      :activePanels="activePanel"
      :useDefaultHeader="false" >

      <template slot="title" slot-scope="titleSlot">
        <VcDocItem :title="titleSlot.item.name"
                   :uid="titleSlot.item.uid"
                   :fileSize="titleSlot.item.file.size | sizeStringify "
                   :isSignable="titleSlot.item.signatureRequired"
                   :corruptedLabel="titleSlot.item.errorMessage"
                   :isSignatureRequired="titleSlot.item.signatureRequired"
                   :trimSignable="isMobile"
                   :actions="selectActions(titleSlot)"
                   @onEdit="edit"
                   @onRemove="remove" />
      </template>

      <template slot="content" slot-scope="contentSlot">
        <UploadFileDetailsForm
          :fileDescription="contentSlot.item.description"
          :fileUid="contentSlot.item.uid"
          :fileTitle="contentSlot.item.name"
          @close-dialog="handleCloseDialog"
          @edit-item="(fileUid, newItem) => $emit('edit-item', fileUid, newItem)" />
      </template>

    </ExpansionPanels>

    <div v-else class="empty-state" data-testid="empty-state">
      {{ $t('common.actions.types.document.empty_state') }}
    </div>

  </div>
</template>


<script>

import UploadFileDetailsForm from "@/modules/common/components/UploadFileDetailsForm/UploadFileDetailsForm";
import ExpansionPanels from "@/modules/common/components/ExpansionPanels";

export default {
  name: 'FilesList',
  components: {
    UploadFileDetailsForm,
    ExpansionPanels,
  },
  data() {
    return {
      defaultActions: [
        {
          type: 'onEdit',
          icon: 'magnify_glass',
        },
        {
          type: 'onRemove',
          icon: 'trash',
        }
      ],
      activeActions: [],
      errorActions: [
        {
          type: 'onRemove',
          icon: 'trash',
        }
      ],
    }
  },
  props:{
    filesList: {
      type: Array,
      default: () => []
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    hasFiles() {
      return this.filesList.length
    },
    idEnriched() {
      return this.filesList.map(item => Object.assign(item, {id: item.uid}))
    },
    activePanel() {
      return [this.idEnriched[0].id]
    }
  },
  filters:{
    sizeStringify(value){
      let  sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (value == 0) return '0 Byte';
      let i = parseInt(Math.floor(Math.log(value) / Math.log(1024)));
      return Math.round(value / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }
  },
  methods: {
    selectActions(item) {
      let actions = this.defaultActions;
      if (item.panels === item.idx) {
        actions = this.activeActions;
      } else if (item.item.errorMessage) {
        actions = this.errorActions;
      }
      return actions;
    },
    handleCloseDialog() {
      this.$emit('close-dialog');
    },
    edit(uid) {
      this.$emit('file-action-clicked', 'Edit', uid);
    },
    remove(uid, e) {
      e.stopPropagation();
      this.$emit('file-action-clicked', 'Delete', uid);
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.files-list {

  .empty-state {
    font-size: 13px;
    font-weight: 400;
    color: $grey-color-20;
    padding-block: 23px;
    text-align: center;
  }

  .v-expansion-panel {
    padding: 0;

    &-header {
      padding: 0;

      &__icon {
        display: none;
      }
    }
  }
}

</style>
